import React from 'react';
import { Checkbox } from 'antd';

export const ConfirmationSection = ({
  isConfirmed,
  setIsConfirmed,
  onConfirmationChange,
}) => {
  const handleConfirmationChange = (event) => {
    setIsConfirmed(event.target.checked);
    onConfirmationChange(event.target.checked);
  };

  return (
    <div>
      <div className="relative mt-5 flex items-start">
        <Checkbox
          id="confirmation"
          checked={isConfirmed}
          onChange={handleConfirmationChange}>
          I have checked the accuracy of payment details.
        </Checkbox>
      </div>
    </div>
  );
};
